// extracted by mini-css-extract-plugin
export default {"searchInput":"ApplicationsFilterPanel_searchInput__rC4Au","filterPanelContainer":"ApplicationsFilterPanel_filterPanelContainer__558BP"};